import React, { useCallback, useState } from 'react';
import { EditorHotbarContext } from './EditorHotbar';

interface ToggleHotbarProps {
    children: React.ReactNode,
}


const ToggleHotbar = ({ children }: ToggleHotbarProps) => {
    const [activeElement, setActiveElement] = useState<{id: string, element: JSX.Element }>();

    const handleActiveElementSet = useCallback((id: string, element: JSX.Element) => {
        if(activeElement && activeElement.id === id) {
            setActiveElement(undefined);
            return;
        }
        setActiveElement({ id, element });
    }, [activeElement]);
    return (
        <EditorHotbarContext.Provider value={{ setActiveElement: handleActiveElementSet, id: activeElement?.id }}>
            <div className="absolute top-0 right-0 flex flex-col justify-center pointer-events-none">
                <div
                    className={
                        'bg-deep-blue basis-12 w-18 rounded-bl-xl pointer-events-auto flex flex-col'
                    }
                >
                    {children}
                    {activeElement?.element && (
                        <div className='absolute right-full top-0'>
                            {activeElement.element}
                        </div>
                    )}
                </div>
            </div>
        </EditorHotbarContext.Provider>
    );
};
export default ToggleHotbar;
